// import { combineReducers } from "@reduxjs/toolkit";
// import { baseApi } from "./baseApi";
// import { authSliceReducer } from "../slices/authSlice";
// import { profileSliceReducer } from "../slices/profileSlice";

// const rootReducer = combineReducers({
//   [baseApi.reducerPath]: baseApi.reducer,
//   auth: authSliceReducer,
//     profile: profileSliceReducer, 
// });

// export type RootState = ReturnType<typeof rootReducer>;

// export default rootReducer;




import { combineReducers } from "@reduxjs/toolkit";
import { baseApi } from "./baseApi";
import { authSliceReducer } from "../slices/authSlice";
import { profileSliceReducer } from "../slices/profileSlice";
import userSettingsReducer from "../services/userSettingsSlice"; 

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  auth: authSliceReducer,
  profile: profileSliceReducer,
  userSettings: userSettingsReducer, 
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
